/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Icon } from 'src/components/Icon';
import { IconName } from 'src/components/Icon/Icon.types';
import { FontColors, Margins } from 'src/design-system/style-types';
import { ServerStatus } from 'src/utils/types';

import { style } from './ServerStatusIcon.style';

export interface Props {
  status?: ServerStatus;
  marginBottom?: Margins;
  marginRight?: Margins;
  className?: '';
  isUpdating?: boolean;
  isDecommissioned?: boolean;
}

export const ServerStatusIcon = (props: Props) => {
  const { isUpdating, isDecommissioned, status, className = '' } = props;

  if (!status) {
    return null;
  }

  const getServerStatusColor = (): FontColors => {
    if (isUpdating || isDecommissioned) {
      return 'disabled';
    }

    const map: Record<ServerStatus, FontColors> = {
      online: 'success',
      critical: 'error',
      warning: 'warning',
      restarting: 'grey',
      no_services: 'disabled',
      unknown: 'disabled',
    };

    return map[status];
  };

  const getServerIconName = (): IconName => {
    if (isDecommissioned) {
      return 'cancel alt';
    }

    if (isUpdating || status === 'restarting') {
      return 'loading';
    }

    return 'circle double';
  };

  return (
    <Icon
      data-qa="server-status-icon"
      className={className}
      css={style.container(props)}
      name={getServerIconName()}
      color={getServerStatusColor()}
    />
  );
};
